import { SxProps, Theme } from '@mui/material';

export const MainTabsWrapStyles: SxProps<Theme> = {
  display: 'flex',
  backgroundColor: '#f0f0f0',
  borderBottom: '1px solid #D9D9DE',
  '.Mui-disabled.MuiTabs-scrollButtons': {
    display: 'none',
  },
};

export const MainTabsStyles: SxProps<Theme> = {
  padding: '4px 16px 0',
  marginBottom: '-1px',

  '& .Mui-selected': { backgroundColor: 'white' },
};

export const TabStyles: (params: {
  isActive: boolean;
  isNextActive: boolean;
}) => SxProps<Theme> = (params) => ({
  padding: '0 25px 0 12px',
  height: '50px',
  minHeight: '50px',
  minWidth: '38px',
  borderRadius: '8px 8px 0 0',
  path: {
    stroke: '#161E45',
  },
  '&:first-of-type': {
    paddingRight: '12px',
  },
  '&:hover': {
    backgroundColor: 'customColors.blue.100',
    borderRadius: '0',
  },
  '&:hover div': {
    visibility: 'visible',
    pointerEvents: 'all',
    opacity: '1',
  },
  '&.main-tab--home:hover': {
    backgroundColor: 'customColors.blue.200',
    path: {
      stroke: '#253CA8',
    },
  },
  '.home-icon path': {
    stroke: '#2E5BE2',
  },
  borderBottom: params.isActive ? 'none' : '1px solid #D9D9DE',
  'svg path': {
    stroke: params.isActive ? '#2E5BE2' : '#161E45',
  },
  '&::after': {
    content: '""',
    width: '1px',
    height: '32px',
    backgroundColor: 'customColors.gray.200',
    position: 'absolute',
    right: 0,
    display: params.isActive || params.isNextActive ? 'none' : 'block',
  },
});

export const TabContentStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
};

export const SvgWrapStyles: SxProps<Theme> = {
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  position: 'absolute',
  top: '14px',
  right: '6px',
  visibility: 'hidden',
  opacity: 0,
  // pointerEvents: 'none',
  svg: {
    width: '22px',
    marginTop: '-4px',
    zIndex: '2',
    position: 'relative',
  },
  '&:before': {
    content: '""',
    width: '24px',
    height: '24px',
    position: 'absolute',
    right: '0',
    top: '0',
    backgroundColor: 'customColors.blue.300',
    borderRadius: '5px',
    zIndex: '2',
    visibility: 'hidden',
    opacity: 0,
    pointerEvents: 'none',
    transition: '.1s ease',
  },
  '&:after': {
    content: '""',
    width: '64px',
    height: '47px',
    position: 'absolute',
    right: '-6px',
    pointerEvents: 'none',
    top: '-14px',
    background:
      'linear-gradient(90deg, rgba(220,231,244,0) 0%, rgba(216,228,251,1) 55%)',
  },
  '&:hover': {
    backgroundColor: 'customColors.blue.300',
    '&:before': {
      visibility: 'visible',
      opacity: 1,
    },
  },
};
